import React, { useEffect } from "react";
import "./ShoeCare.css";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import RatingMaxima from "../Maxima/RatingMaxima/RatingMaxima";
import WorntoWow from "./WorntoWow/WorntoWow";
import LaundryPricing from "../Maxima/LaundryPricing/LaundryPricing";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';
import RatingShoeCare from "./RatingShoeCare/RatingShoeCare";
import FromSneakers from "./FromSneakers/FromSneakers";
// import DownloadThe5asecfrom from "../Maxima/Downloadthe5asec/DownloadThe5asec";
import ShoeCareService from "./ShoeCareService";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
const shosecare ="/shoecare.webp";
export default function ShoeCare() {
  const navigate= useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div>
          <section className="hero-section-wash-shooecare mt-5">
  <div className="hero-overlay-wash-fold mt-5">
    <Container fluid="xl" className="py-5 mt-4 h-100">
      <Row className="align-items-center justify-content-center text-center h-100 mt-5">
        <Col lg={8}>
          <h1 className="hero-title mb-4">
          Shoe Care  <br />
          </h1>
     <span className="hero-highlight-wash-fold">
          Restored. Refined. Ready to Wear
            </span>
             <p className="lead mb-4  text-light fw-medium">
                Your shoes say as much as your outfit. Dirt, scuffs, and neglect quietly shorten their life.
              </p>
              <p className=" text-light lh-lg mb-4">
                Our specialist Shoe Care service restores every pair to its best — using products matched to the exact material, not a one-size-fits-all approach. Whether it's your favourite sneakers or your best dress shoes — a well-maintained pair lasts years longer.
              </p>
             <br />
          <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
            <button className="suhedule-btn-dark"
             onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
            BOOK NOW
            </button>

            <button className="view-prices-list"
            onClick={() => navigate("/laundry-price")}>
              VIEW PRICE LIST
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
</section>
 

       <ShoeCareService />
      <div data-aos="fade-up">
        <WorntoWow/>
      </div>
      <div data-aos="fade-up">
        <FromSneakers/>
      </div>
   
       
      
      <div>
      </div>
    </div>

  );
}
